import { get } from 'lodash-es';
import { GlAlert, GlButton, GlFormGroup, GlFormInput } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import produce from 'immer';
import { createAlert } from '../../../../alert.js?vue3';
import { NAMESPACE_GROUP } from '~/issues/constants';
import { __ } from '~/locale';
import SidebarColorPicker from '../../sidebar_color_picker.vue?vue3';
import { workspaceLabelsQueries, workspaceCreateLabelMutation } from '../../../queries/constants';
import { DEFAULT_LABEL_COLOR } from './constants';
const errorMessage = __('Error creating label.');
export default {
    name: 'DropdownContentsCreateViewWidget',
    components: {
        GlAlert,
        GlButton,
        GlFormGroup,
        GlFormInput,
        SidebarColorPicker
    },
    props: {
        fullPath: {
            type: String,
            required: true
        },
        attrWorkspacePath: {
            type: String,
            required: true
        },
        labelCreateType: {
            type: String,
            required: true
        },
        workspaceType: {
            type: String,
            required: true
        },
        searchKey: {
            type: String,
            required: false,
            default: ''
        }
    },
    emits: [
        'hide-create-view',
        'label-created'
    ],
    data () {
        return {
            labelTitle: this.searchKey,
            selectedColor: DEFAULT_LABEL_COLOR,
            labelCreateInProgress: false,
            error: undefined
        };
    },
    computed: {
        disableCreate () {
            return !this.labelTitle.length || !this.selectedColor.length || this.labelCreateInProgress;
        },
        suggestedColors () {
            const colorsMap = gon.suggested_label_colors;
            return Object.keys(colorsMap).map((color)=>({
                    [color]: colorsMap[color]
                }));
        },
        mutationVariables () {
            const variables = {
                title: this.labelTitle,
                color: this.selectedColor
            };
            if (this.labelCreateType) {
                const attributePath = this.labelCreateType === NAMESPACE_GROUP ? 'groupPath' : 'projectPath';
                return {
                    ...variables,
                    [attributePath]: this.attrWorkspacePath
                };
            }
            return variables;
        }
    },
    methods: {
        updateLabelsInCache (store, label) {
            const { query, dataPath } = workspaceLabelsQueries[this.workspaceType];
            const sourceData = store.readQuery({
                query,
                variables: {
                    fullPath: this.fullPath,
                    searchTerm: ''
                }
            });
            // Nothing cached to amend while the labels query is still in flight.
            if (!sourceData) {
                return;
            }
            const collator = new Intl.Collator('en');
            const data = produce(sourceData, (draftData)=>{
                const { nodes } = get(draftData, dataPath);
                nodes.push(label);
                nodes.sort((a, b)=>collator.compare(a.title, b.title));
            });
            store.writeQuery({
                query,
                variables: {
                    fullPath: this.fullPath,
                    searchTerm: ''
                },
                data
            });
        },
        async createLabel () {
            this.labelCreateInProgress = true;
            try {
                const { data: { labelCreate } } = await this.$apollo.mutate({
                    mutation: workspaceCreateLabelMutation[this.workspaceType],
                    variables: this.mutationVariables,
                    update: (store, { data: { labelCreate: { label } } })=>{
                        if (label) {
                            this.updateLabelsInCache(store, label);
                        }
                    }
                });
                if (labelCreate.errors.length) {
                    [this.error] = labelCreate.errors;
                } else {
                    this.$emit('label-created', labelCreate.label);
                }
            } catch  {
                createAlert({
                    message: errorMessage
                });
            }
            this.labelCreateInProgress = false;
        }
    }
};
